// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"67d5a52e","143":"afcf8962","144":"c44837c6","494":"d305ca29","533":"d1e3c96e","651":"c1853bd9","690":"5e414eba","852":"53fc4da2","940":"a476d778"}[chunkId] + ".chunk.js";
};